<template>
  <div class="navbar bg-neutral text-neutral-content shadow-lg">
    <div class="navbar-start">
      <div class="dropdown">
        <label tabindex="0" class="btn btn-ghost lg:hidden">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h8m-8 6h16"
            />
          </svg>
        </label>
        <ul
          tabindex="0"
          class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52"
        >
          <li>
            <span class="font-bold text-lg">Hello, {{ username }}</span>
          </li>
          <li><a @click="logout">Logout</a></li>
        </ul>
      </div>
      <a class="btn btn-ghost normal-case text-xl hidden lg:flex"
        >Sqwerv Admin</a
      >
    </div>
    <div class="navbar-end hidden lg:flex">
      <ul class="menu menu-horizontal px-1 items-center">
        <li>
          <span class="font-bold">Hello, {{ username }}</span>
        </li>
        <li>
          <a @click="logout" class="btn btn-ghost">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const username = computed(() => store.state.username)

const logout = () => {
  store.dispatch('logout')
}
</script>

<style scoped></style>
